import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#A8ACBD",
  fillRule: "evenodd",
  d: "M6.79 17.625c-2.093 0-3.79-1.777-3.79-3.97 0-2.192 1.697-3.97 3.79-3.97.34 0 .666.052.979.139.638-1.975 2.405-3.402 4.496-3.445l.048-.002.048-.002c2.477 0 4.519 1.946 4.812 4.457.182-.033.368-.053.559-.053 1.805 0 3.268 1.532 3.268 3.423 0 1.89-1.463 3.423-3.268 3.423H6.79Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=CloudIcon24.js.map